import "./seoCotizador.css";

interface Props {
    h1: string;
    bajada: string;
    parrafos: string[];
    ctaTexto?: string;
    onCtaClick?: () => void;
    imagenSrc?: string;
}

const Contenido = ({ h1, bajada, parrafos, ctaTexto, onCtaClick }: Omit<Props, "imagenSrc">) => (
    <>
        <h1 className="seo-cotizador-h1">
            {h1}
        </h1>
        <p className="seo-cotizador-bajada">
            {bajada}
        </p>
        {parrafos.map((parrafo, index) => (
            <p key={index} className="seo-cotizador-parrafo">
                {parrafo}
            </p>
        ))}
        {ctaTexto && (
            <div className="seo-cotizador-cta-hero">
                <button type="button" className="btn btn-primary btn-lg" onClick={onCtaClick}>
                    {ctaTexto}
                </button>
            </div>
        )}
    </>
);

export const HeroSeoCotizador = ({ h1, bajada, parrafos, ctaTexto, onCtaClick, imagenSrc }: Props) => {
    return (
        <div className="seo-cotizador-section-hero">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-7">
                        <Contenido h1={h1} bajada={bajada} parrafos={parrafos} ctaTexto={ctaTexto} onCtaClick={onCtaClick} />
                    </div>
                    {imagenSrc && (
                        <div className="col-lg-5 text-center seo-cotizador-hero-media">
                            <img src={imagenSrc} alt="" className="img-fluid" />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
